import { Component, OnInit, AfterViewInit } from '@angular/core';

import * as Services from '@shared/core/services';

import { ModalViewComponent } from '../modal-view.shared.component';

@Component({
    selector: 'shared-modal-for-alert',
    templateUrl: './modal-for-alert.shared.component.html',
    styleUrls: ['./modal-for-alert.shared.component.scss'],
})
export class ModalForAlertComponent extends ModalViewComponent implements OnInit, AfterViewInit {
    constructor(public modalsService: Services.ModalsService, public heightAdjustService: Services.HeightAdjustService) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xsm';
        this.minHeight = 50;
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.handleHeightUpdate();
        }, 50);
    }
}
